module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instance-setting"
  }, [_c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.resourceId
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [(!_vm.moreForm.moreSet) ? _c('translate', [_vm._v("Basic information")]) : _vm._e(), _vm._v(" "), (_vm.moreForm.moreSet) ? _c('translate', [_vm._v("Authentication settings")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-padding",
    slot: "content"
  }, [(!_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.resourceName,
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.addForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.innerIp
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.addForm.ipAddress) + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.os
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.addForm.os === 'win32' ? 'Windows' : 'Linux') + "\n\t\t\t\t")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.userName
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    on: {
      "change": _vm.onUsername
    },
    model: {
      value: (_vm.addForm.username),
      callback: function($$v) {
        _vm.addForm.username = $$v
      },
      expression: "addForm.username"
    }
  }), _vm._v(" "), _c('translate', [_vm._v("Multiple users with semicolons ‘;’")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.port
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.parentId
    },
    on: {
      "change": _vm.onPort
    },
    model: {
      value: (_vm.addForm.port),
      callback: function($$v) {
        _vm.addForm.port = $$v
      },
      expression: "addForm.port"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.flavor
    }
  }, [_c('div', {
    staticClass: "add-textarea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": _vm.parentId
    },
    model: {
      value: (_vm.addForm.flavor),
      callback: function($$v) {
        _vm.addForm.flavor = $$v
      },
      expression: "addForm.flavor"
    }
  })], 1)]), _vm._v(" "), (_vm.addForm.os === 'win32') ? _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.clipboard
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin-right": "16px"
    },
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.addForm.clipboard),
      callback: function($$v) {
        _vm.addForm.clipboard = $$v
      },
      expression: "addForm.clipboard"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.parentId) ? _c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.moreForm.moreSet = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("More")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.moreForm.moreSet) ? _c('el-form', {
    ref: "moreForm",
    attrs: {
      "model": _vm.moreForm,
      "label-width": "120px",
      "show-message": false
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_c('translate', [_vm._v("Host Authentication Mode")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.moreForm.availability,
      "empty-text": _vm.attrText.emptyText
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.attrText.accountName,
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(scope.row.username) + "\n\t\t\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.action
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.onUpload({
                isUpload: true,
                username: scope.row.username,
                resourceId: _vm.resourceId
              })
            }
          }
        }, [_c('translate', [_vm._v("Upload")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.availability
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "disabled": _vm.$store.getters.cluster.detail.info.agent && _vm.$store.getters.cluster.detail.info.agent.status !== 1
          },
          on: {
            "click": function($event) {
              _vm.onTestKeyAvaliable(scope.row)
            }
          }
        }, [_c('translate', [_vm._v("Test")])], 1), _vm._v(" "), (scope.row.test_result === 'pending') ? _c('i', {
          staticClass: "el-icon-loading"
        }) : _vm._e(), _vm._v(" "), (scope.row.test_result === 'disable' || scope.row.test_result === 'enable') ? _c('span', {
          staticClass: "badge",
          class: scope.row.test_result ? (scope.row.test_result !== 'disable' ? 'available' : 'unavailable') : 'unavailable'
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(scope.row.test_result ? (scope.row.test_result !== 'disable' ? _vm.attrText.available : _vm.attrText.unavailable) : _vm.attrText.unavailable) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.attrText.authenticationMode
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-radio-group', {
          model: {
            value: (scope.row.auth_type),
            callback: function($$v) {
              scope.row.auth_type = $$v
            },
            expression: "scope.row.auth_type"
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 0
          }
        }, [_c('translate', [_vm._v("Host Password")])], 1), _vm._v(" "), (_vm.addForm.os == 'linux') ? _c('el-radio', {
          attrs: {
            "label": 1,
            "disabled": !scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)
          }
        }, [_vm._v("SSH KEY")]) : _vm._e(), _vm._v(" "), (_vm.addForm.os == 'win32') ? _c('el-radio', {
          attrs: {
            "label": 1,
            "disabled": !scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)
          }
        }, [_c('translate', [_vm._v("Password-Free Login")])], 1) : _vm._e(), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 2,
            "disabled": !scope.row.test_result || ['disable', 'pending'].includes(scope.row.test_result)
          }
        }, [_c('translate', [_vm._v("Team Account")])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('translate', [_vm._v("Node:")])], 1), _vm._v(" "), _c('p', [(_vm.addForm.os == 'linux') ? _c('translate', [_vm._v(" For SSH KEY authentication or team account authentication on the target host, ensure that the host user password has been verified. ")]) : _vm._e(), _vm._v(" "), (_vm.addForm.os == 'win32') ? _c('translate', [_vm._v(" For password free login or team account authentication on the target host, ensure that the host user password has been verified. ")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isCansubmit || _vm.parentId
    },
    on: {
      "click": function($event) {
        _vm.onSubmitForm()
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-656a89f3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-instance-setting.vue
// module id = 580
// module chunks = 4 5 6